import { h } from 'preact';

import OverlayWrapper from '../../../components/3-molecules/overlay-wrapper/overlay-wrapper';
import WPNDialog from '../../../components/4-organisms/wpn-dialog/wpn-dialog';
import { WPN_POPUP_STATUS } from '../../../../global-store/subjects/auto-push-notifications/get-actions';
import { getLabel } from '../../../../labels/labelling-service';
import Modal from '../../../components/3-molecules/modal/modal';
import { IconFlagGreen } from '../../../components/1-foundation/icons/icons';

export const renderInDialog = ({ state, handlers, htmlProps }) => {
  const onUnsubscribe = state.sdk?.channel?.optedIn ? handlers.handleWPNunsubscribe : undefined;

  return (
    <OverlayWrapper showOverlay={state.popupStatus !== WPN_POPUP_STATUS.NOTHING_IS_SHOWN}>
      {state.popupStatus === WPN_POPUP_STATUS.SHOW_CONFIRM_MODAL && (
        <Modal
          onClose={() => handlers.handleConfirmModalClose(htmlProps.selectBoxes)}
          modifiers={['confirm']}
          title={getLabel('wpn.confirm.dialog.title')}
          description={htmlProps.confirmDialogDescriptionText}
          footerCtaList={[
            {
              modifiers: ['no-outline', 'capitalized'],
              action: () => handlers.handleConfirmModalCancel(htmlProps.selectBoxes),
              label: getLabel('wpn.confirm.dialog.cancel'),
            },
            {
              modifiers: ['no-outline'],
              action: () => handlers.handleConfirmModalInDialogAccept(htmlProps.selectBoxes),
              label: getLabel('wpn.confirm.dialog.accept'),
              hasArrow: true,
            },
          ]}
        />
      )}
      {state.popupStatus === WPN_POPUP_STATUS.SHOW_CONFIRM_MODAL_SUCCESS && (
        <Modal
          onClose={handlers.handleGenericDialogClose}
          modifiers={['confirm', 'confirm-no-description']}
          title={getLabel('wpn.confirm.dialog.success.title')}
          iconComponent={<IconFlagGreen modifiers={['icon-top', 'flag-green']} />}
        />
      )}
      {state.popupStatus === WPN_POPUP_STATUS.SHOW_PREFERENCES_POPUP && (
        <WPNDialog
          title={getLabel('wpn.preferences.dialog.title')}
          selectBoxes={htmlProps.selectBoxes}
          onClose={() => handlers.handlePreferencesDialogClose(htmlProps.selectBoxes)}
          onConfirm={() => handlers.handlePreferencesDialogConfirm(htmlProps.selectBoxes, state.selectedOptions)}
          onUnsubscribe={onUnsubscribe}
          onOptionClick={handlers.handleOptionClick}
          selectedOptions={state.selectedOptions}
          onSwitchClick={handlers.handleSwitchClick}
        />
      )}
      {state.popupStatus === WPN_POPUP_STATUS.SHOW_PREFERENCES_UNSUBSCRIBE_CONFIRM && (
        <Modal
          modifiers={['confirm', 'confirm-no-description']}
          title={getLabel('wpn.preferences.unsub.dialog.title')}
          onClose={() => handlers.handlePreferencesDialogClose(htmlProps.selectBoxes)}
          footerCtaList={[
            {
              modifiers: ['no-outline'],
              action: handlers.handleWPNunsubscribeConfirm,
              label: getLabel('wpn.preferences.unsub.dialog.confirm'),
            },
            {
              modifiers: ['no-outline'],
              label: getLabel('wpn.preferences.unsub.dialog.cancel'),
              action: () => handlers.handlePreferencesDialogClose(htmlProps.selectBoxes),
            },
          ]}
        />
      )}
      {state.popupStatus === WPN_POPUP_STATUS.SHOW_PREFERENCES_UNSUB_SUCCESS && (
        <Modal
          onClose={handlers.handleGenericDialogClose}
          modifiers={['confirm', 'confirm-no-description']}
          title={getLabel('wpn.preferences.unsub.success.dialog.title')}
          iconComponent={<IconFlagGreen modifiers={['icon-top', 'flag-green']} />}
        />
      )}
    </OverlayWrapper>
  );
};
